import { useBreakpoints, breakpointsVuetify } from "@vueuse/core"

const breakpoints = useBreakpoints(breakpointsVuetify)
const isMobile = breakpoints.smaller("sm")
const isSmallerThanMd = breakpoints.smaller("md")
const isSmallerThanLg = breakpoints.smaller("lg")

export { isMobile, breakpoints, isSmallerThanMd, isSmallerThanLg }
